import { render, staticRenderFns } from "./CollectionInstanceUnitEdit.vue?vue&type=template&id=279a51fa"
import script from "./CollectionInstanceUnitEdit.vue?vue&type=script&lang=js"
export * from "./CollectionInstanceUnitEdit.vue?vue&type=script&lang=js"
import style0 from "./CollectionInstanceUnitEdit.vue?vue&type=style&index=0&id=279a51fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports